import lang from '../../../lang/index.js';
export const minimumLength = 8;
export default function password() {
    return this
        .matches(/\w*[a-z]\w*/, lang().validation.passwordLowerCaseLetterRequired())
        .matches(/\d/, lang().validation.passwordNumerRequired())
        .matches(/[!+@#$%^&*()\-_"=+{}; :,<.>]/, lang().validation.passwordSpecialCharacterRequired())
        .min(minimumLength, ({ min }) => lang().validation.passwordMinimumLength(min));
}
//# sourceMappingURL=index.js.map